export const getMockNoDigitalSlots = () => ({
    "data": [
        {
            "type": "InPersonSlotsView",
            "id": "slot-1",
            "attributes": {
                "start": "2025-08-01T10:00:00Z",
                "end": "2025-08-01T11:00:00Z",
                "effective_start": "2025-08-01T09:00:00Z",
                "effective_end": "2025-08-01T12:00:00Z",
                "type": "AVAILABLE",
                "available_social_referents": []
            }
        },
        {
            "type": "InPersonSlotsView",
            "id": "slot-2",
            "attributes": {
                "start": "2025-08-01T10:30:00Z",
                "end": "2025-08-01T12:00:00Z",
                "effective_start": "2025-08-01T10:30:00Z",
                "effective_end": "2025-08-01T12:00:00Z",
                "type": "AVAILABLE",
                "available_social_referents": []
            }
        },
        {
            "type": "InPersonSlotsView",
            "id": "slot-3",
            "attributes": {
                "start": "2025-08-01T13:00:00Z",
                "end": "2025-08-01T14:30:00Z",
                "effective_start": "2025-08-01T13:00:00Z",
                "effective_end": "2025-08-01T14:30:00Z",
                "type": "AVAILABLE",
                "available_social_referents": []
            }
        },
        {
            "type": "InPersonSlotsView",
            "id": "slot-4",
            "attributes": {
                "start": "2025-08-01T15:00:00Z",
                "end": "2025-08-01T16:30:00Z",
                "effective_start": "2025-08-01T15:00:00Z",
                "effective_end": "2025-08-01T16:30:00Z",
                "type": "AVAILABLE",
                "available_social_referents": []
            }
        },
        {
            "type": "InPersonSlotsView",
            "id": "slot-5",
            "attributes": {
                "start": "2025-08-01T16:30:00Z",
                "end": "2025-08-01T18:00:00Z",
                "effective_start": "2025-08-01T16:30:00Z",
                "effective_end": "2025-08-01T18:00:00Z",
                "type": "AVAILABLE",
                "available_social_referents": []
            }
        },
        {
            "type": "InPersonSlotsView",
            "id": "slot-6",
            "attributes": {
                "start": "2025-08-04T09:00:00Z",
                "end": "2025-08-04T10:30:00Z",
                "effective_start": "2025-08-04T09:00:00Z",
                "effective_end": "2025-08-04T10:30:00Z",
                "type": "AVAILABLE",
                "available_social_referents": []
            }
        },
        {
            "type": "InPersonSlotsView",
            "id": "slot-7",
            "attributes": {
                "start": "2025-08-04T10:30:00Z",
                "end": "2025-08-04T12:00:00Z",
                "effective_start": "2025-08-04T10:30:00Z",
                "effective_end": "2025-08-04T12:00:00Z",
                "type": "AVAILABLE",
                "available_social_referents": []
            }
        },
        {
            "type": "InPersonSlotsView",
            "id": "slot-8",
            "attributes": {
                "start": "2025-08-04T13:00:00Z",
                "end": "2025-08-04T14:30:00Z",
                "effective_start": "2025-08-04T13:00:00Z",
                "effective_end": "2025-08-04T14:30:00Z",
                "type": "AVAILABLE",
                "available_social_referents": []
            }
        },
        {
            "type": "InPersonSlotsView",
            "id": "slot-9",
            "attributes": {
                "start": "2025-08-04T15:00:00Z",
                "end": "2025-08-04T16:30:00Z",
                "effective_start": "2025-08-04T15:00:00Z",
                "effective_end": "2025-08-04T16:30:00Z",
                "type": "AVAILABLE",
                "available_social_referents": []
            }
        },
        {
            "type": "InPersonSlotsView",
            "id": "slot-10",
            "attributes": {
                "start": "2025-08-04T16:30:00Z",
                "end": "2025-08-04T18:00:00Z",
                "effective_start": "2025-08-04T16:30:00Z",
                "effective_end": "2025-08-04T18:00:00Z",
                "type": "UNAVAILABLE",
                "available_social_referents": []
            }
        },
        {
            "type": "InPersonSlotsView",
            "id": "slot-11",
            "attributes": {
                "start": "2025-08-05T09:00:00Z",
                "end": "2025-08-05T10:30:00Z",
                "effective_start": "2025-08-05T09:00:00Z",
                "effective_end": "2025-08-05T10:30:00Z",
                "type": "AVAILABLE",
                "available_social_referents": []
            }
        },
        {
            "type": "InPersonSlotsView",
            "id": "slot-12",
            "attributes": {
                "start": "2025-08-05T10:30:00Z",
                "end": "2025-08-05T12:00:00Z",
                "effective_start": "2025-08-05T10:30:00Z",
                "effective_end": "2025-08-05T12:00:00Z",
                "type": "AVAILABLE",
                "available_social_referents": []
            }
        },
        {
            "type": "InPersonSlotsView",
            "id": "slot-13",
            "attributes": {
                "start": "2025-08-05T13:00:00Z",
                "end": "2025-08-05T14:30:00Z",
                "effective_start": "2025-08-05T13:00:00Z",
                "effective_end": "2025-08-05T14:30:00Z",
                "type": "UNAVAILABLE",
                "available_social_referents": []
            }
        },
        {
            "type": "InPersonSlotsView",
            "id": "slot-14",
            "attributes": {
                "start": "2025-08-05T15:00:00Z",
                "end": "2025-08-05T16:30:00Z",
                "effective_start": "2025-08-05T15:00:00Z",
                "effective_end": "2025-08-05T16:30:00Z",
                "type": "AVAILABLE",
                "available_social_referents": []
            }
        },
        {
            "type": "InPersonSlotsView",
            "id": "slot-15",
            "attributes": {
                "start": "2025-08-05T16:30:00Z",
                "end": "2025-08-05T18:00:00Z",
                "effective_start": "2025-08-05T16:30:00Z",
                "effective_end": "2025-08-05T18:00:00Z",
                "type": "AVAILABLE",
                "available_social_referents": []
            }
        },
        {
            "type": "InPersonSlotsView",
            "id": "slot-16",
            "attributes": {
                "start": "2025-08-06T09:00:00Z",
                "end": "2025-08-06T10:30:00Z",
                "effective_start": "2025-08-06T09:00:00Z",
                "effective_end": "2025-08-06T10:30:00Z",
                "type": "AVAILABLE",
                "available_social_referents": []
            }
        },
        {
            "type": "InPersonSlotsView",
            "id": "slot-17",
            "attributes": {
                "start": "2025-08-06T10:30:00Z",
                "end": "2025-08-06T12:00:00Z",
                "effective_start": "2025-08-06T10:30:00Z",
                "effective_end": "2025-08-06T12:00:00Z",
                "type": "UNAVAILABLE",
                "available_social_referents": []
            }
        },
        {
            "type": "InPersonSlotsView",
            "id": "slot-18",
            "attributes": {
                "start": "2025-08-06T13:00:00Z",
                "end": "2025-08-06T14:30:00Z",
                "effective_start": "2025-08-06T13:00:00Z",
                "effective_end": "2025-08-06T14:30:00Z",
                "type": "AVAILABLE",
                "available_social_referents": []
            }
        },
        {
            "type": "InPersonSlotsView",
            "id": "slot-19",
            "attributes": {
                "start": "2025-08-06T15:00:00Z",
                "end": "2025-08-06T16:30:00Z",
                "effective_start": "2025-08-06T15:00:00Z",
                "effective_end": "2025-08-06T16:30:00Z",
                "type": "AVAILABLE",
                "available_social_referents": []
            }
        },
        {
            "type": "InPersonSlotsView",
            "id": "slot-20",
            "attributes": {
                "start": "2025-08-06T16:30:00Z",
                "end": "2025-08-06T18:00:00Z",
                "effective_start": "2025-08-06T16:30:00Z",
                "effective_end": "2025-08-06T18:00:00Z",
                "type": "AVAILABLE",
                "available_social_referents": []
            }
        },
        {
            "type": "InPersonSlotsView",
            "id": "slot-21",
            "attributes": {
                "start": "2025-08-07T09:00:00Z",
                "end": "2025-08-07T10:30:00Z",
                "effective_start": "2025-08-07T09:00:00Z",
                "effective_end": "2025-08-07T10:30:00Z",
                "type": "AVAILABLE",
                "available_social_referents": []
            }
        },
        {
            "type": "InPersonSlotsView",
            "id": "slot-22",
            "attributes": {
                "start": "2025-08-07T10:30:00Z",
                "end": "2025-08-07T12:00:00Z",
                "effective_start": "2025-08-07T10:30:00Z",
                "effective_end": "2025-08-07T12:00:00Z",
                "type": "AVAILABLE",
                "available_social_referents": []
            }
        },
        {
            "type": "InPersonSlotsView",
            "id": "slot-23",
            "attributes": {
                "start": "2025-08-07T13:00:00Z",
                "end": "2025-08-07T14:30:00Z",
                "effective_start": "2025-08-07T13:00:00Z",
                "effective_end": "2025-08-07T14:30:00Z",
                "type": "AVAILABLE",
                "available_social_referents": []
            }
        },
        {
            "type": "InPersonSlotsView",
            "id": "slot-24",
            "attributes": {
                "start": "2025-08-07T15:00:00Z",
                "end": "2025-08-07T16:30:00Z",
                "effective_start": "2025-08-07T15:00:00Z",
                "effective_end": "2025-08-07T16:30:00Z",
                "type": "UNAVAILABLE",
                "available_social_referents": []
            }
        },
        {
            "type": "InPersonSlotsView",
            "id": "slot-25",
            "attributes": {
                "start": "2025-08-07T16:30:00Z",
                "end": "2025-08-07T18:00:00Z",
                "effective_start": "2025-08-07T16:30:00Z",
                "effective_end": "2025-08-07T18:00:00Z",
                "type": "AVAILABLE",
                "available_social_referents": []
            }
        },
        {
            "type": "InPersonSlotsView",
            "id": "slot-26",
            "attributes": {
                "start": "2025-08-08T09:00:00Z",
                "end": "2025-08-08T10:30:00Z",
                "effective_start": "2025-08-08T09:00:00Z",
                "effective_end": "2025-08-08T10:30:00Z",
                "type": "AVAILABLE",
                "available_social_referents": []
            }
        },
        {
            "type": "InPersonSlotsView",
            "id": "slot-27",
            "attributes": {
                "start": "2025-08-08T10:30:00Z",
                "end": "2025-08-08T12:00:00Z",
                "effective_start": "2025-08-08T10:30:00Z",
                "effective_end": "2025-08-08T12:00:00Z",
                "type": "AVAILABLE",
                "available_social_referents": []
            }
        },
        {
            "type": "InPersonSlotsView",
            "id": "slot-28",
            "attributes": {
                "start": "2025-08-08T13:00:00Z",
                "end": "2025-08-08T14:30:00Z",
                "effective_start": "2025-08-08T13:00:00Z",
                "effective_end": "2025-08-08T14:30:00Z",
                "type": "AVAILABLE",
                "available_social_referents": []
            }
        },
        {
            "type": "InPersonSlotsView",
            "id": "slot-29",
            "attributes": {
                "start": "2025-08-08T15:00:00Z",
                "end": "2025-08-08T16:30:00Z",
                "effective_start": "2025-08-08T15:00:00Z",
                "effective_end": "2025-08-08T16:30:00Z",
                "type": "AVAILABLE",
                "available_social_referents": []
            }
        },
        {
            "type": "InPersonSlotsView",
            "id": "slot-30",
            "attributes": {
                "start": "2025-08-08T16:30:00Z",
                "end": "2025-08-08T18:00:00Z",
                "effective_start": "2025-08-08T16:30:00Z",
                "effective_end": "2025-08-08T18:00:00Z",
                "type": "AVAILABLE",
                "available_social_referents": []
            }
        }
    ]
});